import React, { useState } from 'react';
import { FormData, Program } from '../types';
import FormModal from './FormModal';
import ProgramCard from './ProgramCard';
import './ProgramsPage.css';

const programs: Program[] = [
  {
    id: 2,
    title: 'Vista Tech Internship',
    content: `Benefits of the Program:
• Experts Training
• Course Certification
• Internship Certification
• LinkedIn Endorsement
• Letter of Recommendation`,
    sheetUrl: 'AKfycbwPEsy6mqsLMVZaY7ZoEMYe14_L7vnBYlOKHQAqqOrcBLvHQRn2guOhQ_H8RTom0lTl',
    emailMessage: 'You have a webinar meeting at 7 PM. Meeting link: https://meet.google.com/axr-eprz-aiw'
  }
];

const ProgramsPage: React.FC = () => {
  const [selectedProgram, setSelectedProgram] = useState<Program | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleCardClick = (program: Program) => {
    setSelectedProgram(program);
    setIsModalOpen(true);
    setFormSubmitted(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = async (formData: FormData): Promise<void> => {
    if (!selectedProgram) return Promise.reject(new Error("No program selected"));

    try {
      // Submit to Google Sheets using the program's specific sheet URL
      const response = await submitToGoogleSheets(formData);
      
      if (response.success) {
        // Simulate a delay to make the loading state visible for at least 1 second
        // This helps users perceive that something is happening
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Send email notification
        await sendEmailNotification(formData.email, selectedProgram.emailMessage);
        setFormSubmitted(true);
        return Promise.resolve();
      } else {
        return Promise.reject(new Error('Form submission failed'));
      }
    } catch (error) {
      console.error('Form submission error:', error);
      return Promise.reject(error);
    }
  };

  const submitToGoogleSheets = async (formData: FormData) => {
    // Using a single Web App URL for all programs
    const url = `https://script.google.com/macros/s/AKfycbyWXbm3E9Akv5WBb_5NUcMejd1c7KUXnLiYU3eqsX1OUUi2TRKY6QVBTBJsKNzObbGy/exec`;
    
    try {
      // Log form data before sending to help with debugging
      console.log('Submitting form data:', formData);
      
      const response = await fetch(url, {
        method: 'POST',
        mode: 'no-cors', // This is important for Google Apps Script
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      // Since we're using no-cors, we can't actually read the response
      return { success: true };
    } catch (error) {
      console.error('Google Sheets submission error:', error);
      return { success: false };
    }
  };

  const sendEmailNotification = async (email: string, message: string) => {
    // In a real application, you would connect to an email service
    // This is a placeholder function
    console.log(`Sending email to ${email} with message: ${message}`);
    return { success: true };
  };

  return (
    <div className="programs-page">
      <div className="fractal-pattern"></div>
      <header className="page-header">
        <h1>Vista Tech Programs</h1>
        <p className="page-subheader">
          Launch your career with our industry-aligned tech programs designed for real-world success. 
          Choose the path that best fits your goals and transform your future.
        </p>
      </header>
      <div className="programs-container">
        {programs.map((program) => (
          <ProgramCard 
            key={program.id} 
            program={program} 
            onClick={() => handleCardClick(program)} 
          />
        ))}
      </div>
      {selectedProgram && (
        <FormModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          program={selectedProgram}
          onSubmit={handleFormSubmit}
          formSubmitted={formSubmitted}
        />
      )}
    </div>
  );
};

export default ProgramsPage;